import React, { useState, useEffect } from 'react'
import axios from 'axios'
import API_URL from '../apiUrl'

const DownloadCSV = () => {
    const [students, setStudents] = useState(null);

    const getAllStudents = async () => {
        try{
            const students = await axios.get(`${API_URL}students/all_students`);
            const result = await students.data;
            setStudents(result)
        }
        catch(error){
            console.error(error)
        }
    }

    useEffect(() => {
        getAllStudents();
    }, [])

    function flattenObject(obj, parentKey = '') {
        if(!obj) return;
        const result = Object.keys(obj).reduce((acc, key) => {
            const preKey = parentKey ? `${parentKey}_` : '';
            if (typeof obj[key] === 'object') {
                Object.assign(acc, flattenObject(obj[key], `${preKey}${key}`));
            } else {
                acc[`${preKey}${key}`] = obj[key];
            }
            return acc;
        }, {});
        return result;
    }
    
    const handleDownload = () => {
      function downloadJSONAsCSV(jsonData) {
        // Fetch JSON data from the endpoint
        let csvData = jsonToCsv(jsonData);

        // Create a CSV file and allow the user to download it
        let blob = new Blob([csvData], { type: "text/csv" });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "data.csv";
        document.body.appendChild(a);
        a.click();
      }

      function jsonToCsv(jsonData) {
        let csv = "";
    
        // Get the headers
        let headers = Object.keys(jsonData[0]);
       
        if (Array.isArray(headers)) {
          csv += headers.join(",") + "\n";
      }
    
        // Add the data
        jsonData.forEach(function (row) {
            let data = headers.map(header => {
                if (Array.isArray(row[header]) && row[header].includes(',')) {
                  return `"${row[header].join(',')}"`; // Assuming you want to join the array elements with a comma
              } else if (typeof row[header] === 'string' && row[header].includes(',')) {
                  return `"${row[header]}"`; // If it's a string, you can directly apply the logic
              } else {
                  return row[header]; // Handle other cases as needed
              }
            }).join(",");
            csv += data + "\n";
        });
        console.log(csv);
        return csv;
    }
    

    //   const parsedStudent = JSON.parse(JSON.stringify(studentJSON));
      const flattenStudent = students?.map((student) => {
        return {...flattenObject(student)}});
     students && downloadJSONAsCSV(flattenStudent);
    };



  return (
    <div className='w-full flex justify-center items-center gap-6 bg-gray-200 py-4'>
        <p className='capitalize text-base text-gray-700 font-semibold'>Download CSV file of all the Students Records.</p>
      <button onClick={handleDownload} className='bg-gray-800 text-white text-sm font-semibold px-3 py-2 rounded-md hover:bg-blue-600 transition-all duration-600'>Download</button>
    </div>
  )
}

export default DownloadCSV
